import validator from "validator";

const validationEmail = (email?: string) => {
  if (!email || typeof email !== "string") return false;
  const asciiEmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!asciiEmailRegex.test(email)) return false;
  return validator.isEmail(email, { allow_utf8_local_part: false });
};

export default validationEmail;
